import { formatInTimeZone, fromZonedTime } from "date-fns-tz";

export const SOUTH_AFRICA_TIME_ZONE = "Africa/Johannesburg";
export const SOUTH_AFRICA_TIME_LABEL = "SAST";

const toValidDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const parseSouthAfricaDateTimeLocal = (value) => {
  if (!value) return null;
  const date = fromZonedTime(value, SOUTH_AFRICA_TIME_ZONE);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatSouthAfricaDateTimeLocal = (value) => {
  const date = toValidDate(value);
  if (!date) return "";
  return formatInTimeZone(date, SOUTH_AFRICA_TIME_ZONE, "yyyy-MM-dd'T'HH:mm");
};

export const formatSouthAfricaDateTime = (
  value,
  pattern = "EEE, dd MMM, HH:mm",
) => {
  const date = toValidDate(value);
  if (!date) return "";
  return formatInTimeZone(date, SOUTH_AFRICA_TIME_ZONE, pattern);
};

export const formatSouthAfricaTime = (value) =>
  formatSouthAfricaDateTime(value, "HH:mm");
